import { useMutation } from "@apollo/client";
import { clientSaleManagement } from "config/apollo/apollo.config";
import { CREATE_PROSPECT } from "queries/saleManagement";

export default function useCreateProspect() {
  const [createPropspect, { loading }] = useMutation<CreateProspectOutput, CreateProspectInput>(
    CREATE_PROSPECT,
    {
      client: clientSaleManagement,
    },
  );

  return { createPropspect, loading };
}
